import React from 'react';
import Nav from '../../Utils/Nav';
import banner from '../../Assets/background2.JPG'
import Footer from '../../Utils/Footer';

const SupportTeam = () => {

    const teamMembers = [
    {
      name: "Vikram Singh Shekhawat",
      designation: "Junior Technical Superintendent, IT Section",
      photo: "https://www.iitrpr.ac.in/it/static/media/vikram.40c1a912d746c8839f07.jpg",
      email: "jts.it@iitrpr.ac.in",
      phone: "01881235134",
    },
  ];

  return (
     <>
       <Nav/>
       <div className='main-container'>
       <div className="banner">
                   <img className="background" src={banner} alt="" />
               <h1 className="main-heading-title">Support Team</h1>
       
               </div>
      <div style={styles.supportContainer}>
      <div style={styles.grid}>
        {teamMembers.map((member, index) => (
        <div key={index} style={styles.card}>
      <img src={member.photo} alt={member.name} style={styles.photo} />
      <div style={styles.info}>
        <h3 style={styles.name}>{member.name}</h3>
        <p style={styles.designation}>{member.designation}</p>
        <p style={styles.designation}>{member.email}</p>
        <p style={styles.designation}>{member.phone}</p>
      </div>
    </div>
        ))}
      </div>
    </div>
    </div>
    <Footer/>
    </>
  )
}

// Inline styles
const styles = {
  supportContainer: {
    maxWidth: 900,
    margin: "60px auto",
    padding: "0 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    textAlign: "center",
    
  },
  grid: {
    display: "flex",
    justifyContent: "center",
    gap: 20,
    flexWrap: "nowrap",
    overflowX: "auto",
  },
  card: {
    backgroundColor: "#f9f9f9",
    borderRadius: 10,
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    width: 500,
    padding: 20,
    textAlign: "center",
  },
  photo: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: 15,
  },
  name: {
    margin: "10px 0 5px 0",
    fontSize: 20,
    fontWeight: "600",
  },
  designation: {
    margin: 0,
    fontSize: 16,
    color: "#555",
  },
};

export default SupportTeam
